import { useAuth } from '@clerk/nextjs'
import Image from 'next/image'
import Link from 'next/link'

import { websitePaths } from 'domains/website/website.paths'
import { getDocsQuickStartPath } from 'lib/routes/replace-dynamic-paths'
import { useTheme } from 'lib/themes/use-theme'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'
import BgDark from 'components/pages/@shared/@assets/squares-bg-dark.png'
import BgLight from 'components/pages/@shared/@assets/squares-bg-light.png'

const SharedCta = ({
  title = 'Get Started',
  description = 'Start building your backend of the future now.'
}) => {
  const { isDarkTheme } = useTheme()
  const { isSignedIn } = useAuth()

  return (
    <Box
      relative
      css={{
        py: 50,
        width: '100%'
      }}
    >
      <Image
        src={isDarkTheme ? BgDark : BgLight}
        fill
        alt="Bg"
        style={{ objectFit: 'contain' }}
      />
      <Box css={{ container: 'xl' }}>
        <Box
          flex={{ '@initial': 'column', '@sm': true }}
          items={{ '@initial': 'start', '@sm': 'center' }}
          justify={{ '@initial': 'start', '@sm': 'between' }}
          css={{
            container: 'lg',
            border: '1px solid $bg3',
            borderRadius: '$xl',
            padding: '$10',
            background: 'rgba(255, 255, 255, 0.01)'
          }}
        >
          <Box>
            <Text
              as="h2"
              weight="bold"
              size={{ '@initial': '4xl', '@sm': '5xl' }}
            >
              {title}
            </Text>
            <Box css={{ mt: '$3' }}>
              <Text as="p" size="xl" color="text2">
                {description}
              </Text>
            </Box>
          </Box>
          <Box css={{ mt: '$4', '@sm': { mt: 'unset' } }}>
            <Link
              href={
                isSignedIn ? getDocsQuickStartPath() : websitePaths.register
              }
            >
              <Button variant="gradient" size="lg" css={{ fontSize: '$xl' }}>
                Start Building
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SharedCta
